import emptyState from "../store/emptyState";
import globalReducerHelper from "./globalReducerHelper";

const seo = (state = emptyState.seo, action) => {
  if (!state) return {};

  const { type, payload } = action;

  switch (type) {
    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.seo,
        emptyState.seo
      );
  }
};

export default seo;
